<div class="service-config-modal-content fd-modal-content">
  <h3 fxLayoutAlign="center">Configurar tecnologia</h3>
  <form [formGroup]="formGroup">
      <div fxLayout="column" fxLayoutAlign="center">
          <div fxLayoutGap="20px">
              <div fxFlex="50">
                  <fd-input [parentForm]="formGroup" [field]="fields.institutionNumber"></fd-input>
              </div>
              <div fxFlex="50">
                  <fd-input [parentForm]="formGroup" [field]="fields.seriviceContract"></fd-input>
              </div>
          </div>
          <div fxLayoutGap="20px">
              <div fxFlex="50">
                  <fd-input [parentForm]="formGroup" [field]="fields.serviceID"></fd-input>
              </div>
              <div fxFlex="50">
                  <fd-input [parentForm]="formGroup" [field]="fields.typeTerminal"></fd-input>
              </div>
          </div>
          <div>
              <fd-input [parentForm]="formGroup" [field]="fields.name"></fd-input>
          </div>
          <div *ngIf="isConfigTechnologyAble">
              <fd-input [parentForm]="formGroup" [field]="fields.disclaimer"></fd-input>
          </div>
          <div fxLayoutGap="20px">
              <div fxFlex="50">
                  <fd-select [parentForm]="formGroup" [field]="fields.type" (selectionChange)="checkType()">
                  </fd-select>
              </div>
              <div *ngIf="isVenda" fxFlex="50">
                  <fd-select [parentForm]="formGroup" [field]="fields.producer">
                  </fd-select>
              </div>
          </div>
          <div fxLayoutGap="20px">
              <div fxFlex="50" *ngIf="!isCnp">
                  <span class="device-on-agency-container">Máquina na Agência</span>
                  Não <mat-slide-toggle formControlName="deviceOnAgency" style="padding: 0 4px;"></mat-slide-toggle> Sim
              </div>
          </div>
        <div class="toggles-container">
          <div fxFlexAlign="center">
            <h4 class="toggle-item">Habilitação Tecnologia</h4>
            <mat-slide-toggle class="toggle-item" formControlName="status" (change)="toggleChange($event)"> {{checkToggle(formGroup.controls.status.value)}} </mat-slide-toggle>
          </div>
          <div fxFlexAlign="center" *ngIf="isConfigTechnologyAble">
            <h4 class="toggle-item">Tecnologia Piloto</h4>
            <mat-slide-toggle class="toggle-item" formControlName="piloto" (change)="toggleChange($event)"> {{checkToggle(formGroup.controls.piloto.value)}} </mat-slide-toggle>
          </div>
        </div>
        <div class="technology-container" *ngIf="isConfigTechnologyAble">
          <div class="options-image-container">
              <h4>Imagem tecnologia</h4>
              <fd-image-uploader style="width: 100%;" (onImageSelected)="onImageSelected($event)" (onImageDeleted)="onImageDeleted()" [imageUrl]="imageLoadedUrl">
              </fd-image-uploader>
          </div>
          <div>
              <fd-input
                  [hidden]="imageFile == null && imageLoadedUrl == null"
                  [parentForm]="formGroup"
                  [field]="fields.imageDescription"
                  fxFlex=100 >
              </fd-input>
          </div>
          <div fxLayoutGap="50px">
            <div fxFlex="50">
                <h4>Vantagens*</h4>
                <fd-multiple-text-field placeholder="Digite uma vantagem" [(items)]="advantagesObject.advantages"></fd-multiple-text-field>
            </div>
            <div fxFlex="50">
                <h4>Detalhes*</h4>
                <fd-multiple-text-field placeholder="Digite um detalhe" [(items)]="detailsObject.details"></fd-multiple-text-field>
            </div>
          </div>
        </div>
      </div>
  </form>

  <div mat-dialog-actions align="center">
      <div>
          <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"> </fd-button>
          <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="save()"> </fd-button>
      </div>
  </div>
</div>
